import { useRef, useState } from "react";
import clsx from "clsx";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import styles from "./index.module.scss";

export default function SliderMobile({ images, alt }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef();
  return (
    <div className={styles.SliderMobile}>
      <div>
        <Swiper
          className={styles.Swiper}
          ref={sliderRef}
          watchSlidesProgress={true}
          navigation={true}
          slidesPerView={1}
          // Соседний слайд подгружаем заранее, остальные — по мере листания
          lazyPreloadPrevNext={1}
          modules={[Navigation]}
          onActiveIndexChange={(swiper) => {
            setActiveIndex(swiper.activeIndex);
          }}
        >
          {images.map((item, index) => (
            <SwiperSlide key={index}>
              {item.isVideo ? (
                <iframe
                  src={item.full}
                  frameBorder={0}
                  allowFullScreen="allowfullscreen"
                ></iframe>
              ) : (
                // Виден один слайд, а грузились сразу все фото товара (у TowRus
                // для Jetour T2 — 29 штук, ~485 КБ) и забивали медленный канал
                <img
                  itemProp="image"
                  src={item.small}
                  alt={alt}
                  loading={index === 0 ? "eager" : "lazy"}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={styles.Thumbs}>
        {images.map((image, index) => (
          <span
            key={index}
            onClick={() => {
              setTimeout(() => {
                sliderRef.current.swiper.slideTo(index);
              });
            }}
            style={{ backgroundImage: `url(${image?.thumb})` }}
            className={clsx(
              styles.Thumb,
              activeIndex === index && styles.ThumbActive,
            )}
          ></span>
        ))}
      </div>
    </div>
  );
}
